import { Box } from "@mui/material";
import Chip from "@mui/material/Chip";
import React from "react";

import { RobotoTypography } from "@/shared/components";

import { DevicesTableFilter } from "./types";

interface DeviceFilterChipProps {
  name: string;
  value: string | null;
  onDelete: () => void;
}

export interface DevicesTableFilterChipsProps {
  filter: DevicesTableFilter;
  setFilter: (filter: DevicesTableFilter) => void;
}

const DeviceFilterChip: React.FC<DeviceFilterChipProps> = ({
  name,
  value,
  onDelete,
}) => {
  return (
    <Chip
      label={
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <RobotoTypography
            variant="body2"
            sx={{ fontSize: "0.8rem", fontWeight: 300 }}
          >
            {name}
          </RobotoTypography>
          <RobotoTypography
            variant="body2"
            sx={{ fontSize: "0.8rem", fontWeight: 300 }}
          >
            |
          </RobotoTypography>
          <RobotoTypography
            variant="body2"
            sx={{ fontSize: "0.8rem", fontWeight: 500 }}
          >
            {value}
          </RobotoTypography>
        </Box>
      }
      onDelete={onDelete}
    />
  );
};

export const DevicesTableFilterChips: React.FC<
  DevicesTableFilterChipsProps
> = ({ filter, setFilter }) => {
  return (
    <Box
      sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}
    >
      {filter.createdBy && (
        <DeviceFilterChip
          name="Created By"
          value={filter.createdBy}
          onDelete={() => {
            setFilter({ ...filter, createdBy: null });
          }}
        />
      )}
      {filter.deviceId && (
        <DeviceFilterChip
          name="Device ID"
          value={filter.deviceId}
          onDelete={() => {
            setFilter({ ...filter, deviceId: null });
          }}
        />
      )}
    </Box>
  );
};
